import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import { useAPI } from '../../api';
import { AccountInfo } from 'types';

import AccountsListContainer from './AccountsListContainer';
import AccountCreateNewContainer from './AccountCreateNewContainer';
import AccountContainer from './AccountContainer';

const AccountsContainer = () => {
	const api = useAPI();

	const [accounts, setAccounts] = useState<AccountInfo[]>([]);

	const loadAccounts = () => {
		api.get<AccountInfo[]>('/api/accounts')
		.then(json => setAccounts(json));
	};

	useEffect(() => {
		loadAccounts();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Routes>
			<Route path="/" element={<AccountsListContainer accounts={accounts} onChanged={loadAccounts} />} />
			<Route path="/new" element={<AccountCreateNewContainer onChanged={loadAccounts} />} />
			<Route path="/:accountID/*" element={<AccountContainer />} />
		</Routes>
	);
};

export default AccountsContainer;
